import { ResponseDto } from '@diritto/common/base/response.dto';
import { UpdateReplyDto } from '@diritto/common/reply/dtos/create-reply.dto';
import { ReplyLikeResponseDto } from '@diritto/common/reply/dtos/reply-like.response.dto';
import { ReplyReportResponseDto } from '@diritto/common/reply/dtos/reply-report.dtos';
import { ReplyReportRequestDto } from '@diritto/common/reply/dtos/reply-report.request.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class ReplyApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async updateReply(replyId: number, data: UpdateReplyDto) {
    const res = await this.http.put<UpdateReplyDto, ResponseDto>(`${this.url}/replies/${replyId}`, data);
    return res.data;
  }

  async deleteReply(replyId: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/replies/${replyId}/schedule`);
    return res.data;
  }

  async getReplyLikes(replyIds: number[]): Promise<ReplyLikeResponseDto> {
    const res = await this.http.get<ReplyLikeResponseDto>(`${this.url}/reply/likes?replyIds=${replyIds.join(',')}`);
    return res.data;
  }

  async likeReply(replyId: number): Promise<ResponseDto> {
    const res = await this.http.post<undefined, ResponseDto>(`${this.url}/replies/${replyId}/like`);
    return res.data;
  }

  async unlikeReply(replyId: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/replies/${replyId}/like`);
    return res.data;
  }

  async isReported(replyId: number) {
    const res = await this.http.get<ReplyReportResponseDto>(`${this.url}/replies/${replyId}/report`);
    return res.data;
  }

  async reportReply(replyId: number, payload: ReplyReportRequestDto): Promise<ResponseDto> {
    const res = await this.http.post<ReplyReportRequestDto, ResponseDto>(
      `${this.url}/replies/${replyId}/report`,
      payload,
    );
    return res.data;
  }
}
